module.exports = {
      id: "bookmark-outline-usage",
      viewBox: "0 0 24 36",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#bookmark-outline",
      toString: function () {
        return this.url;
      }
    }